var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTarget(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 79,
    viewBox: "0 0 80 79",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Target"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 322",
    d: "M68.4883 63.9932C68.4883 66.2023 66.6974 67.9932 64.4883 67.9932H39.7203C23.8223 67.9932 10.9343 55.1007 10.9343 39.2027C10.9343 23.3096 23.8182 10.4212 39.7113 10.4212C55.6044 10.4212 68.4883 23.3051 68.4883 39.1982V63.9932Z",
    fill: "#284993"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 323",
    d: "M63.957 59.46C63.957 61.6691 62.1662 63.46 59.957 63.46H39.7194C26.325 63.46 15.4667 52.5978 15.4667 39.2034C15.4667 25.8132 26.3216 14.9544 39.7119 14.9544C53.1021 14.9544 63.957 25.8094 63.957 39.1996V59.46Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 324",
    d: "M59.4258 54.9268C59.4258 57.1359 57.6349 58.9268 55.4258 58.9268H39.7186C28.8278 58.9268 19.9991 50.0949 19.9991 39.2041C19.9991 28.3168 28.825 19.4877 39.7124 19.4877C50.5998 19.4877 59.4258 28.3137 59.4258 39.2011V54.9268Z",
    fill: "#284993"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 325",
    d: "M54.8945 50.3965C54.8945 52.6045 53.1045 54.3945 50.8965 54.3945H39.7177C31.3306 54.3945 24.5314 47.593 24.5314 39.2058C24.5314 30.8213 31.3284 24.0219 39.713 24.0219C48.0975 24.0219 54.8945 30.8189 54.8945 39.2035V50.3965Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 326",
    d: "M50.3613 46.0744C50.3613 48.1653 48.6663 49.8604 46.5754 49.8604H39.7149C33.8314 49.8604 29.0618 45.0891 29.0618 39.2056C29.0618 33.3239 33.8299 28.5542 39.7116 28.5542C45.5933 28.5542 50.3613 33.3222 50.3613 39.2039V46.0744Z",
    fill: "#284993"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTarget);
export default __webpack_public_path__ + "static/media/Target.aae0f07992727a651780c91be8215edc.svg";
export { ForwardRef as ReactComponent };